import { Controller, useFormContext } from "react-hook-form";

import type { FCWithChildren } from "koljobs-types";

import {
  Checkbox,
  CheckboxProps,
} from "@/features/common/components/form/Checkbox";
import { EditModelAlbumFormInputs } from "@/features/modelPhoto/contexts/useEditModelAlbumFormContext";

export const SelectablePhotoWrapper: FCWithChildren<
  {
    value: string;
    disabled: boolean;
  } & Pick<CheckboxProps, "disabled" | "value">
> = ({ children, disabled, value }) => {
  const { control } = useFormContext<EditModelAlbumFormInputs>();

  return (
    <Controller
      control={control}
      name="modelPhotoIds"
      render={({ field: { onChange, ...rest } }) => (
        <Checkbox
          {...rest}
          disabled={disabled}
          variant="custom"
          label={children}
          value={value}
          checked={
            Array.isArray(rest.value) ? rest.value.includes(value) : false
          }
          onChange={(e) => {
            if (e.target.checked) {
              onChange([...(rest.value ?? []), e.target.value]);
              return;
            }
            onChange(rest.value?.filter((x) => x !== value));
          }}
        />
      )}
    />
  );
};
